"use strict";
/*
 * Created on 6. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UploadNotification_1 = require("../../data-upload/model/UploadNotification");

var UploadNotificationSeverityEnum_1 = require("../../data-upload/model/UploadNotificationSeverityEnum");

var UploadValidityEnum_1 = require("../../data-upload/model/UploadValidityEnum");
/**
 * Info about product prices data upload.
 *
 * @author Radek Beran
 */


var ProductPricesUpload =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductPricesUpload, _DomainObject_1$Domai);

  /**
   * Creates new product prices upload object.
   * @param id identification of this upload
   * @param releaseId release id; null only in old data
   * @param date the date of the upload
   * @param validity upload result/validity
   * @param importedRowsCount the number of successfully imported rows
   * @param progressMonitorId id of progress monitor for price upload; null if upload is already not in progress
   * @param notifications the list of upload notifications
   */
  function ProductPricesUpload(id, releaseId, // null only for backward compatibility
  date, validity, importedRowsCount, progressMonitorId, // TODO LOG-5679: Add total rows count
  notifications) {
    var _this;

    _classCallCheck(this, ProductPricesUpload);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPricesUpload).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.date = date;
    _this.validity = validity;
    _this.importedRowsCount = importedRowsCount;
    _this.progressMonitorId = progressMonitorId;
    _this.notifications = notifications;
    return _this;
  }

  _createClass(ProductPricesUpload, [{
    key: "withError",
    value: function withError(text, params, lineNumber) {
      var severity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : UploadNotificationSeverityEnum_1.UploadNotificationSeverityEnum.ERROR;
      var notification = {
        text: text,
        severity: severity
      };

      if (params) {
        notification.params = params;
      }

      if (lineNumber) {
        notification.lineNumber = lineNumber;
      }

      return this.copy('validity', UploadValidityEnum_1.UploadValidityEnum.INVALID).copy('notifications', this.notifications.push(notification));
    }
  }]);

  return ProductPricesUpload;
}(DomainObject_1.DomainObject);

exports.ProductPricesUpload = ProductPricesUpload;

ProductPricesUpload.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductPricesUpload.name);
  return {
    id: builder.str('id'),
    releaseId: builder.opt(builder.str('releaseId')),
    date: builder.date('date'),
    validity: builder.str('validity'),
    importedRowsCount: builder.opt(builder.num('importedRowsCount')),
    progressMonitorId: builder.opt(builder.str('progressMonitorId')),
    notifications: builder.listOf(UploadNotification_1.createUploadNotificationSchema(builder, 'notifications'))
  };
}();
/**
 * Common upload (validation) errors which can happen during price uploads. It is meant to be used
 * in `text` of `UploadNotification` and then translated on FE.
 *
 * @author Jan Prokop
 */


var ProductPricesUploadError;

(function (ProductPricesUploadError) {
  ProductPricesUploadError["RequiredFieldMissing"] = "RequiredFieldMissing";
  ProductPricesUploadError["DateInThePast"] = "DateInThePast";
  ProductPricesUploadError["InvalidPrice"] = "InvalidPrice";
  ProductPricesUploadError["EndDateBeforeStartDate"] = "EndDateBeforeStartDate";
  ProductPricesUploadError["ProductNotInRelease"] = "ProductNotInRelease";
  ProductPricesUploadError["PriceZoneNotInRelease"] = "PriceZoneNotInRelease";
  ProductPricesUploadError["ProductNotListedInPriceZone"] = "ProductNotListedInPriceZone";
  ProductPricesUploadError["UnknownExternalGOSId"] = "UnknownExternalGOSId";
  ProductPricesUploadError["UnknownPriceZoneName"] = "UnknownPriceZoneName";
  ProductPricesUploadError["UnknownPriceCode"] = "UnknownPriceCode";
  ProductPricesUploadError["IncorrectDataFormat"] = "IncorrectDataFormat";
  ProductPricesUploadError["UnknownOrInactiveProduct"] = "UnknownOrInactiveProduct";
  ProductPricesUploadError["UnknownProduct"] = "UnknownProduct";
  ProductPricesUploadError["InvalidSelloutProductSiteTuple"] = "InvalidSelloutProductSiteTuple";
  ProductPricesUploadError["ProductSiteInAnotherRelease"] = "ProductSiteInAnotherRelease";
  ProductPricesUploadError["SelloutRestrictedProduct"] = "SelloutRestrictedProduct";
  ProductPricesUploadError["GOSIntersection"] = "GOSIntersection";
})(ProductPricesUploadError = exports.ProductPricesUploadError || (exports.ProductPricesUploadError = {}));